export default "__VITE_ASSET__CdheqnOm__"